import { Component, Input } from '@angular/core';

@Component({
  selector: 'tooltip-component',
  templateUrl: './tooltip.component.html',
})

export class TooltipComponent {
  @Input() tooltipContent: string;
  @Input() ordinalNumber?: number;

  public isTooltipVisible = false;
  public translateTooltip = false;

  constructor() {}
}
